import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { User } from '@schenck/rotec-components';
import { API_BASE_URL } from './tokens';

@Injectable()
export class FilterApi {
  private readonly baseUrl = inject(API_BASE_URL);
  private readonly http = inject(HttpClient);

  public userUrl: string;

  constructor() {
    const baseUrl = this.baseUrl;

    this.userUrl = baseUrl + '/Users/Editors';
  }

  getUsers$() {
    return this.http.get<User[]>(this.userUrl);
  }
}
